/**
 * @file Automatically generated by barrelsby.
 */

export * from './mat-label-with-value.component';
export * from './mat-label-with-value.model';
